<div class="modal fade" id="kt_modal_bank_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Bank' : 'Add Bank' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="bankForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <!-- Nav Tabs -->
          <ul class="nav nav-tabs nav-line-tabs mb-5 fs-6">
            <li class="nav-item">
              <a class="nav-link active" data-bs-toggle="tab" href="#kt_tab_english">
                <i class="ki-duotone ki-flag fs-2 me-2">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                English
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_japanese">
                <i class="ki-duotone ki-flag fs-2 me-2">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                Japanese (日本語)
              </a>
            </li>
          </ul>

          <!-- Tab Content -->
          <div class="tab-content" id="myTabContent">
            <!-- English Tab -->
            <div class="tab-pane fade show active" id="kt_tab_english" role="tabpanel">
              <div class="row">
                <!-- Bank Name -->
                <div class="col-md-6 mb-5">
                  <label class="form-label required">Bank Name</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="name"
                    placeholder="Enter bank name"
                    [class.is-invalid]="name?.invalid && name?.touched"
                  />
                  <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                    <div *ngIf="name?.errors?.['required']">Bank name is required</div>
                    <div *ngIf="name?.errors?.['minlength']">Bank name must be at least 2 characters</div>
                  </div>
                </div>

                <!-- Branch Name -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Branch Name</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="branch_name"
                    placeholder="Enter branch name"
                    [class.is-invalid]="branch_name?.invalid && branch_name?.touched"
                  />
                  <div *ngIf="branch_name?.invalid && branch_name?.touched" class="invalid-feedback">
                    <div *ngIf="branch_name?.errors?.['required']">Branch name is required</div>
                  </div>
                </div>

                <!-- Branch Code -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Branch Code</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="branch_code"
                    placeholder="Enter branch code"
                    [class.is-invalid]="branch_code?.invalid && branch_code?.touched"
                  />
                  <div *ngIf="branch_code?.invalid && branch_code?.touched" class="invalid-feedback">
                    <div *ngIf="branch_code?.errors?.['required']">Branch code is required</div>
                  </div>
                </div>

                <!-- Account Name -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Account Name</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="account_name"
                    placeholder="Enter account name"
                    [class.is-invalid]="account_name?.invalid && account_name?.touched"
                  />
                  <div *ngIf="account_name?.invalid && account_name?.touched" class="invalid-feedback">
                    <div *ngIf="account_name?.errors?.['required']">Account name is required</div>
                  </div>
                </div>

                <!-- Account Number -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Account Number</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="account_number"
                    placeholder="Enter account number"
                    [class.is-invalid]="account_number?.invalid && account_number?.touched"
                  />
                  <div *ngIf="account_number?.invalid && account_number?.touched" class="invalid-feedback">
                    <div *ngIf="account_number?.errors?.['required']">Account number is required</div>
                  </div>
                </div>

                <!-- Swift Code -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Swift Code</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="swift_code"
                    placeholder="Enter swift code"
                    [class.is-invalid]="swift_code?.invalid && swift_code?.touched"
                  />
                  <div *ngIf="swift_code?.invalid && swift_code?.touched" class="invalid-feedback">
                    <div *ngIf="swift_code?.errors?.['required']">Swift code is required</div>
                  </div>
                </div>

                <!-- Address -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Address</label>
                  <textarea
                    class="form-control form-control-solid"
                    formControlName="address"
                    placeholder="Enter address"
                    rows="3"
                    [class.is-invalid]="address?.invalid && address?.touched">
                  </textarea>
                  <div *ngIf="address?.invalid && address?.touched" class="invalid-feedback">
                    <div *ngIf="address?.errors?.['required']">Address is required</div>
                  </div>
                </div>

                <!-- Beneficiary Address -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Beneficiary Address</label>
                  <textarea
                    class="form-control form-control-solid"
                    formControlName="beneficiary_address"
                    placeholder="Enter beneficiary address"
                    rows="3"
                    [class.is-invalid]="beneficiary_address?.invalid && beneficiary_address?.touched">
                  </textarea>
                  <div *ngIf="beneficiary_address?.invalid && beneficiary_address?.touched" class="invalid-feedback">
                    <div *ngIf="beneficiary_address?.errors?.['required']">Beneficiary address is required</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Japanese Tab -->
            <div class="tab-pane fade" id="kt_tab_japanese" role="tabpanel">
              <div class="row">
                <!-- Bank Name (Japanese) -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Bank Name (日本語)</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="name_jpy"
                    placeholder="銀行名を入力してください"
                    [class.is-invalid]="name_jpy?.invalid && name_jpy?.touched"
                  />
                  <div *ngIf="name_jpy?.invalid && name_jpy?.touched" class="invalid-feedback">
                    <div *ngIf="name_jpy?.errors?.['required']">Bank name is required</div>
                  </div>
                </div>

                <!-- Branch Name (Japanese) -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Branch Name (日本語)</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="branch_name_jpy"
                    placeholder="支店名を入力してください"
                    [class.is-invalid]="branch_name_jpy?.invalid && branch_name_jpy?.touched"
                  />
                  <div *ngIf="branch_name_jpy?.invalid && branch_name_jpy?.touched" class="invalid-feedback">
                    <div *ngIf="branch_name_jpy?.errors?.['required']">Branch name is required</div>
                  </div>
                </div>

                <!-- Branch Code (Japanese) -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Branch Code (日本語)</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="branch_code_jpy"
                    placeholder="支店コードを入力してください"
                    [class.is-invalid]="branch_code_jpy?.invalid && branch_code_jpy?.touched"
                  />
                  <div *ngIf="branch_code_jpy?.invalid && branch_code_jpy?.touched" class="invalid-feedback">
                    <div *ngIf="branch_code_jpy?.errors?.['required']">Branch code is required</div>
                  </div>
                </div>

                <!-- Account Name (Japanese) -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Account Name (日本語)</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="account_name_jpy"
                    placeholder="口座名を入力してください"
                    [class.is-invalid]="account_name_jpy?.invalid && account_name_jpy?.touched"
                  />
                  <div *ngIf="account_name_jpy?.invalid && account_name_jpy?.touched" class="invalid-feedback">
                    <div *ngIf="account_name_jpy?.errors?.['required']">Account name is required</div>
                  </div>
                </div>

                <!-- Account Number (Japanese) -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Account Number (日本語)</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="account_number_jpy"
                    placeholder="口座番号を入力してください"
                    [class.is-invalid]="account_number_jpy?.invalid && account_number_jpy?.touched"
                  />
                  <div *ngIf="account_number_jpy?.invalid && account_number_jpy?.touched" class="invalid-feedback">
                    <div *ngIf="account_number_jpy?.errors?.['required']">Account number is required</div>
                  </div>
                </div>

                <!-- Swift Code (Japanese) -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Swift Code (日本語)</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    formControlName="swift_code_jpy"
                    placeholder="SWIFTコードを入力してください"
                    [class.is-invalid]="swift_code_jpy?.invalid && swift_code_jpy?.touched"
                  />
                  <div *ngIf="swift_code_jpy?.invalid && swift_code_jpy?.touched" class="invalid-feedback">
                    <div *ngIf="swift_code_jpy?.errors?.['required']">Swift code is required</div>
                  </div>
                </div>

                <!-- Address (Japanese) -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Address (日本語)</label>
                  <textarea
                    class="form-control form-control-solid"
                    formControlName="address_jpy"
                    placeholder="住所を入力してください"
                    rows="3"
                    [class.is-invalid]="address_jpy?.invalid && address_jpy?.touched">
                  </textarea>
                  <div *ngIf="address_jpy?.invalid && address_jpy?.touched" class="invalid-feedback">
                    <div *ngIf="address_jpy?.errors?.['required']">Address is required</div>
                  </div>
                </div>

                <!-- Beneficiary Address (Japanese) -->
                <div class="col-md-6 mb-5">
                  <label class="form-label">Beneficiary Address (日本語)</label>
                  <textarea
                    class="form-control form-control-solid"
                    formControlName="beneficiary_address_jpy"
                    placeholder="受取人住所を入力してください"
                    rows="3"
                    [class.is-invalid]="beneficiary_address_jpy?.invalid && beneficiary_address_jpy?.touched">
                  </textarea>
                  <div *ngIf="beneficiary_address_jpy?.invalid && beneficiary_address_jpy?.touched" class="invalid-feedback">
                    <div *ngIf="beneficiary_address_jpy?.errors?.['required']">Beneficiary address is required</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
